import type React from 'react';
import {MdAddCircleOutline} from 'react-icons/md';

type Props = {
  onClick: () => void;
  variant?: 'pc' | 'sp';
};

/**
 * エントリー管理追加ボタン
 * PC版とSP版で異なるサイズを適用
 */
export const AddEntryButton: React.FC<Props> = ({onClick, variant = 'pc'}) => {
  const isPc = variant === 'pc';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-4 px-12 py-8 bg-primary text-white rounded-full font-bold ${isPc ? 'hover:opacity-80' : ''}`}
    >
      <MdAddCircleOutline size={isPc ? 20 : 18} />
      {isPc && 'Add'}
    </button>
  );
};
